import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StudijnyProgram } from '../model/studijny-program';

@Component({
    selector: 'app-studijne-programy',
    templateUrl: './studijne-programy.component.html',
    styleUrls: ['./studijne-programy.component.css'],
    standalone: false
})
export class StudijneProgramyComponent implements OnInit {

  studProgramy: StudijnyProgram[] = [];
  checked = false;

  constructor(
    public dialogRef: MatDialogRef<StudijneProgramyComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMatDialog: {studProgramy: StudijnyProgram[]}
  ) { }

  ngOnInit(): void {

    // console.log('stud. programy: ' + JSON.stringify(this.dataMatDialog.studProgramy));

    this.studProgramy = this.dataMatDialog.studProgramy;

  }

  selectAll() {
    this.studProgramy.forEach(sp => {
      sp.zaradeny = this.checked ? true : false;
    });
  }
}
